import React, { useEffect, useState } from 'react';

const Scanner = () => {
  const [qrData, setQrData] = useState(null);
  const queryParams = new URLSearchParams(window.location.search);
  const link = queryParams.get('link');

  useEffect(() => {
    if (link) {
      fetch(`https://aivoice.passionit.com/scanner-api/qrcodeinfo/bylink?link=${encodeURIComponent(link)}`)
        .then(response => response.json())
        .then(data => {
          setQrData(data);
        })
        .catch(error => {
          console.error('Error fetching QR info:', error);
        });
    }
  }, [link]);

  if (!link) {
    return <div>No QR code link provided.</div>;
  }

  if (!qrData) {
    return <div>Loading QR code info...</div>;
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">QR Code Information</h2>
      <table className="table-auto border border-gray-300 w-full">
        <tbody>
          <tr><td className="border p-2">Chart Name</td><td className="border p-2">{qrData.chartname}</td></tr>
          <tr><td className="border p-2">Language</td><td className="border p-2">{qrData.language}</td></tr>
          <tr><td className="border p-2">Religion</td><td className="border p-2">{qrData.religion}</td></tr>
          <tr><td className="border p-2">Avatar</td><td className="border p-2">{qrData.avatar}</td></tr>
          <tr><td className="border p-2">Voice</td><td className="border p-2">{qrData.voice}</td></tr>
          <tr><td className="border p-2">Vedio</td><td className="border p-2">{qrData.vedio}</td></tr>
          <tr><td className="border p-2">Mood</td><td className="border p-2">{qrData.mood}</td></tr>
          <tr><td className="border p-2">Age Group</td><td className="border p-2">{qrData.agegroup}</td></tr>
          <tr><td className="border p-2">Term</td><td className="border p-2">{qrData.term}</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default Scanner;
